import angular, { IPromise } from "angular";

import { vsName as processModuleName } from "../../../Process";
import {
  configureDetailView,
  ProcessGroupConfig,
} from "../../../Process/config";
import {
  ProcessInformationService,
  ProcessInformationServiceProvider,
  vsServiceName as ProcessInformationServiceName,
  vsProviderName as ProcessInformationServiceProviderName,
} from "../../../Process/services/processInformationService";
import {
  SelectRecordModalService,
  vsServiceName as SelectRecordModalServiceName,
} from "../../../records/services/selectRecordModal";
import {
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../records/views/recordGridView";
import { machineObjectName } from "../../shared/names";
import { vsProviderName as MachineDetailTabsProviderName } from "../../shared/components/views/machines/detail/tabs";
import {
  AuthorizedUiElementConfig,
  AuthorizedUiElementServiceProvider,
} from "../../../ui/authorizedUiElement";
import { Machine } from "../models/machine";
import { ProcessInformation } from "../../../Process/model/ProcessGroups";
import { StateService } from "@uirouter/angularjs";
import { processRouteConfig } from "./routes";
import {
  ColumnDefinitionSetService,
  vsServiceName as ColumnDefinitionSetServiceName,
} from "../../../records/grids/columns/columnDefinitionSetService";

export const vsModuleName = "cachecreek.process";

angular
  .module(
    vsModuleName,
    [processModuleName],
    [
      ProcessInformationServiceProviderName,
      MachineDetailTabsProviderName,
      (
        processInformationServiceProvider: ProcessInformationServiceProvider,
        machineDetailTabsServiceProvider: AuthorizedUiElementServiceProvider<AuthorizedUiElementConfig>
      ) => {
        const cacheCreekMachineProcessConfig: ProcessGroupConfig = {
          processGroupId: "machine",
          processDetailTemplate:
            require("!html-loader!./machineProcessDetail.html").default,
          additionalGridColumns: [
            ColumnDefinitionSetServiceName,
            (columnDefinitionSetService: ColumnDefinitionSetService) =>
              columnDefinitionSetService.getColumnDefinitionSet(
                machineObjectName
              ),
          ],
          getCreateProcessDto: [
            "dataObject",
            (dataObject) => ({
              MachineId: dataObject.Id,
            }),
          ],
          onSelectDataObject: [
            SelectRecordModalServiceName,
            RecordGridViewServiceName,
            "$q",
            (
              selectRecordModalService: SelectRecordModalService,
              recordGridViewService: RecordGridViewService
            ) =>
              selectRecordModalService.openModal({
                gridConfiguration:
                  recordGridViewService.getGridConfiguration(
                    machineObjectName
                  )!,
                onItemSelected: (item, modalInstance) =>
                  modalInstance.close(item),
                title: "Select Machine",
              }).result,
          ],
        };

        processInformationServiceProvider.addRuntimeConfig(
          cacheCreekMachineProcessConfig
        );

        configureDetailView(
          cacheCreekMachineProcessConfig,
          machineDetailTabsServiceProvider,
          ["machine", (machine: Machine) => ({ MachineId: machine.Id })],
          [
            "machine",
            "$state",
            ProcessInformationServiceName,
            (
              machine: Machine,
              $state: StateService,
              processInformationService: ProcessInformationService
            ) => [
              "process",
              (process: ProcessInformation) =>
                processInformationService
                  .createProcess(process, {
                    MachineId: machine.Id,
                  })
                  .then((r) =>
                    $state.go(
                      `${machineDetailTabsServiceProvider.basePath}.process.detail`,
                      {
                        processInstancesId: r.Id,
                        groupId: r.GroupId,
                      }
                    )
                  ),
            ],
          ]
        );
      },
    ]
  )
  .config(processRouteConfig);
